import React from 'react';

interface Props {
  label?: string;
  backgroundColor?: string;
  textColor?: string;
  className?: string;
}

export default function CustomLabel(props: Props) {
  const { label, backgroundColor, textColor, className } = props;

  const container =
    'flex flex-wrap justify-center flex-shrink items-center rounded-[6px] lg:px-[5px] px-[3px] py-2xs relative overflow-hidden';

  return (
    <div className={`${container} ${className}`} style={{ backgroundColor: backgroundColor }}>
      <span className="text-center line-clamp-1" style={{ color: textColor }}>
        {label}
      </span>
    </div>
  );
}
